// app.config.ts
import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import routes from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideOAuthClient, OAuthService } from 'angular-oauth2-oidc';
import { mpInterceptor } from './core/interceptors/mp.interceptor';
import { AppConfigService } from './core/services/app-config/app-config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptors([mpInterceptor])
    ),
    provideOAuthClient(),
    provideAppInitializer(async () => {
      const appConfigService = inject(AppConfigService);
      const oauth = inject(OAuthService);

      const authConfig = await appConfigService.loadAuthConfig();
      oauth.configure(authConfig as any);

      const isOAuthCallback = new URLSearchParams(window.location.search).has('code');
      await oauth.tryLoginCodeFlow();
      if (isOAuthCallback && oauth.hasValidAccessToken()) {
        sessionStorage.setItem('post_login_snackbar', 'true');
      }
    }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      })
    ),
  ],
};
